module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['form-group', _vm.errors[_vm.attribute] ? 'has-error' : '']
  }, [_vm._t("default"), _vm._v(" "), (_vm.errors[_vm.attribute]) ? _c('p', {
    staticClass: "help-block"
  }, [_vm._v("\n    " + _vm._s(_vm.errors[_vm.attribute][0]) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70ebd222"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormError.vue
// module id = 817
// module chunks = 1